module.exports = __WEBPACK_EXTERNAL_MODULE__965__;